export const oneTrustPrivacyNoticeId = '73437d9d-e07d-47b8-83da-a2b0385b4633';

const storageContainerId = '69c54d66-b534-485c-8541-afe1ce4e0b7a';

export const oneTrustPrivacyNoticeUrl = {
  draft: `https://privacyportal-cdn.onetrust.com/storage-container/${storageContainerId}/privacy-notices/${oneTrustPrivacyNoticeId}/draft/privacynotice.json`,
  published: `https://privacyportal-cdn.onetrust.com/storage-container/${storageContainerId}/privacy-notices/${oneTrustPrivacyNoticeId}/published/privacynotice.json`
};

// Base64 settings copied verbatim from the OneTrust-provided SDK snippets — decodes to the
// contentApiUrl/metadataApiUrl (and, for published, a view-stats callbackUrl) OneTrust's script reads.
export const oneTrustPrivacyNoticeSettings = {
  draft:
    'eyJjb250ZW50QXBpVXJsIjoiaHR0cHM6Ly9wcml2YWN5cG9ydGFsLm9uZXRydXN0LmNvbS9yZXF1ZXN0L3YxL2VudGVycHJpc2Vwb2xpY3kvZGlnaXRhbHBvbGljeS9jb250ZW50IiwibWV0YWRhdGFBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L21ldGEtZGF0YSJ9',
  published:
    'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyIsImNvbnRlbnRBcGlVcmwiOiJodHRwczovL3ByaXZhY3lwb3J0YWwub25ldHJ1c3QuY29tL3JlcXVlc3QvdjEvZW50ZXJwcmlzZXBvbGljeS9kaWdpdGFscG9saWN5L2NvbnRlbnQiLCJtZXRhZGF0YUFwaVVybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0='
};
